import { mixed } from 'yup';
import { useSearchParams } from 'next/navigation';

import { CUSTOMER_PRODUCT_TYPES } from '../../../../types/state/customer';
import type { CustomerProductType } from '../../../../types/state/customer';

const productTypeSchema = mixed<CustomerProductType>().oneOf([...CUSTOMER_PRODUCT_TYPES]);

const useQueryProductType = () => {
  const searchParams = useSearchParams();
  const value = searchParams.get('type');

  return productTypeSchema.isValidSync(value, { strict: true }) ? value : undefined;
};

export default useQueryProductType;
